import { Button, Menu, MenuItem } from "@mui/material"
import React, { useState } from "react";
import { FavouritesContext } from "./favouritesProvider";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { IQuestion } from "../types";
import { TotalMarks } from "../item/totalMarks";
import { Helpers } from "../helpers/helpers";
import { DownloadPdfModal } from "../modal/downloadPdfModal";

interface FavouritesMenuProps {
    items: IQuestion[];
}

export const FavouritesMenu = (props: FavouritesMenuProps) => {
    const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleAlbumMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <>
            <Button sx={{ marginRight: "20px !important" }}
                variant="outlined"
                endIcon={<ArrowDropDownIcon />}
                onClick={handleAlbumMenu}
                aria-label="album"
                color="inherit" >
                {props.items.length} favourite{props.items.length > 1 && "s"}
                <TotalMarks
                    outOf={Helpers.sum(props.items.map(i => i.num_marks))}
                    isBottomCorner={true} />
            </Button>

            {/* <Button
                variant="outlined"
                startIcon={<ClearIcon />}
                onClick={() => { clearAlbum(); }}
                aria-label="album"
                color="inherit" >
                Remove all
            </Button> */}

            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                sx={{ margin: "10px" }}
            >
                <MenuItem>
                    <Button
                        variant="outlined"
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => { setShowDownloadModal(true) }}
                        aria-label="download"
                        color="inherit" >
                        Download as pdf
                    </Button>
                    <DownloadPdfModal
                        open={showDownloadModal}
                        setOpen={setShowDownloadModal}
                        items={props.items}
                    />
                </MenuItem>

            </Menu>
        </>
    )
}